import { BrowserRouter, Routes, Route } from 'react-router-dom'
import HomePage from '@/pages/HomePage'
import TasksPage from '@/pages/TasksPage'
import WalletPage from '@/pages/WalletPage'
import SkillsPage from '@/pages/SkillsPage'
import SettingsPage from '@/pages/SettingsPage'
import ProfilePage from '@/pages/ProfilePage'
import MessagesPage from '@/pages/MessagesPage'
import ArtifactsPage from '@/pages/ArtifactsPage'
import BotCreatePage from '@/pages/BotCreatePage'
import ValidatorPage from '@/pages/ValidatorPage'
import ContactsPage from '@/pages/ContactsPage'
import NotFoundPage from '@/pages/NotFoundPage'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/wallet" element={<WalletPage />} />
        <Route path="/skills" element={<SkillsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/artifacts" element={<ArtifactsPage />} />
        <Route path="/bot/create" element={<BotCreatePage />} />
        <Route path="/validator" element={<ValidatorPage />} />
        <Route path="/contacts" element={<ContactsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  )
}
